import React, {
  createContext,
  useReducer,
  useState,
  useEffect,
  useContext
} from 'react'
import { Promise } from 'es6-shim'
import { Button } from 'syngenta-react-components'
import DetailView from '../../../dpe-usco/components/Details/DetailView'
import CompanyDetailsWidget from './CompanyDetailsWidget'
import DeliveryLocationWidget from './DeliveryLocationWidget'
import AvailableContractTypesWidget from './AvailableContractTypesWidget'
import UploadLegalFilesWidget from './UploadLegalFilesWidget'
import { LanguageContext } from '../../../services/context'
import DeliveryWidget from './DeliveryWidget'
import {
  getContractTypes,
  patchProductionPlan,
  getProductionPlan,
  patchContractTemplate,
  getContractTemplates,
  uploadContractTemplate,
  getLanguageByCompany
} from '../../../services/apiHelper'
import { GlobalContext, AuthContext } from '../../../services/context'
import { useParams } from 'react-router-dom'
import ParentProductionPlanWidget from './ParentProductionPlanWidget'
import AccessDeniedView from '../../Interstitial/AccessDeniedView'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'
import ProductionPlanModal from './ProductionPlanModal'
export const ProductionPlanContext = createContext()


const ProductionPlanReducer = (state, action) => {
  switch (action.type) {
    case 'POSTS_COMPLETE':
      return {
        ...state,
        showModal: true,
        submissionStatus: action.payload.submissionStatus,
        dispatchObj: action.payload?.dispatchObj
      }
    case 'SET_MODAL': {
      let showModal = action.payload === 'SUCCESS' ? true : false
      return { ...state, showModal }
    }
    case 'START_POST': {
      return { ...state, showModal: true, submissionStatus: 'LOADING' }
    }
    case 'UPDATE_COMPANY_DETAILS':
      return {
        ...state,
        company_details: action.payload,
        updateCompanyDetails: true
      }
    case 'FINISHED_UPDATING_COMPANY':
      return { ...state, updateCompanyDetails: false }
    case 'UPDATE_DELIVERY_LOCATION':
      return { ...state, delivery_location: action.payload }
    case 'UPDATE_SELECTED_CONTRACT_TYPE':
      return { ...state, selected_contract_type: action.payload }
    case 'UPDATE_LEGAL_FILES': {
      const newState = { ...state }
      if (action.payload) {
        newState.legal_files = action.payload
        newState.errors = { ...newState.errors, legal_files: [] }
      }
      if(action.payload && (action.companyLang.length === action.payload.length)) {
        newState.errors = { ...newState.errors, legal_files: [] }
      }
      return newState
    }
    case 'UPDATE_MONTHLY_UNITS': {
      const newState = { ...state }
      if (action.payload.length) {
        newState.monthly_units = action.payload
        for(let i = 0; i < action.payload.length; i++){
          if(action.payload[i].premium_type){
            newState.premium_type = action.payload[i].premium_type
            break
          }
        }
        newState.errors = { ...newState.errors, delivery: [] }
      } else {
        //newState.monthly_units = []
        newState.errors = {
          ...newState.errors,
          delivery: [
            ...newState.errors.delivery,
            'Must have at least one completed delivery row'
          ]
        }
      }
      return newState
    }
    case 'UPDATE_TOTAL_ACRES':
      return { ...state, total_acres: action.payload.toString() }
    case 'UPDATE_TOTAL_UNITS':
      return { ...state, total_units: action.payload.toString() }
    case 'UPDATE_TOTAL_CHILD_ACRES':
      return { ...state, total_child_acres: action.payload.toString() }
    case 'UPDATE_TOTAL_CHILD_UNITS':
      return { ...state, total_child_units: action.payload.toString() }
    case 'UPDATE_APH':
      return { ...state, aph: action.payload.toString() }
    case 'UPDATE_PROD_PLAN_INVENTORY':
      return { ...state, inventory_code: action.payload }
    case 'UPDATE_CONTRACT_YEAR':
      return { ...state, contract_year: parseInt(action.payload) }
    case 'UPDATE_PARENT_PRODUCTION_PLAN':
      return { ...state, parent_production_plan_id: action.payload.production_plan_id, parent_production_plan: action.payload.prod_plan_obj }
    case 'CANCEL_EDIT':
      return { ...state }
    case 'HAS_COMPANY_ID':
      return {
        ...state,
        company_name: action.payload.company_name,
        external_reference_id: action.payload.external_reference_id,
        company_id: action.payload.external_reference_id
      }
    case 'HAS_CONTEXT':
      return {
        ...state,
        company_name: action.payload.company_name,
        external_reference_id: action.payload.external_reference_id,
        company_id: action.payload.external_reference_id,
        parent_production_plan_id: action.payload.parent_production_plan_id,
        company_inventory_code: action.payload.company_inventory_code
      }
    case 'ERRORS': {
      const newState = { ...state, rightSideState: 'FAILED' }
      for (let widget in newState.errors) {

        if(!Object.prototype.hasOwnProperty.call(action.payload,widget)){
          newState.errors[widget] = []
        }
      }
      for (let widget in action.payload) {
        newState.errors[widget]=[]
        newState.errors[widget].push(action.payload[widget])
      }
      return newState
    }
    case 'NOERRORS': {
      const newState = { ...state, rightSideState: 'SUCCESS' }
      for (let widget in newState.errors) {
        if(!Object.prototype.hasOwnProperty.call(action.payload,widget)){
          newState.errors[widget] = []
        }
      }
      for (let widget in action.payload) {
        newState.errors[widget]=[]
        newState.errors[widget].push(action.payload[widget])
      }
      return newState
    }
    case 'UPDATE_CONTRACT_YEAR_ERROR': {
      const newState = { ...state }
      const isProductionPlanExist = action.payload.prodPlanData.some(data => data.contract_year === action.payload.contractYear && data.production_plan_id !== action.payload.production_plan_id)
      if (isProductionPlanExist) {
        newState.errors = {
          ...newState.errors,
          contract_year: ['Production plan already exists for this year']
        }
      } else {
        newState.errors = { ...newState.errors, contract_year: [] }
      }
      return newState
    }
    default:
      throw new Error()
  }
}

const EditProductionPlanView = () => {
  const { dispatch, trackEvent } = useContext(GlobalContext)
  const { hasAccess } = useContext(AuthContext)
  const [contractTypes, setContractTypes] = useState([])
  const[prevPremiumType, setPrevPremiumType] = useState('')
  const [
    initial_delivery_location_data,
    set_initial_delivery_location_data
  ] = useState()
  const [initial_total_units, set_initial_total_units] = useState()
  const [initial_contract_year, set_initial_contract_year] = useState()
  const [initial_aph, set_initial_aph] = useState()
  const [initial_prod_inventory, set_initial_prod_inventory] = useState()
  const [initial_contract_type, set_initial_contract_type] = useState()
  const [initial_total_acres, set_initial_total_acres] = useState()
  const [initial_monthly_units, set_initial_monthly_units] = useState()
  const [
    initial_parent_production_plan,
    set_initial_parent_production_plan
  ] = useState()
  const [initial_master_agreement, set_initial_master_agreement] = useState()
  const [hasPermissison, setHasPermission] = useState('LOADING')
  const { production_plan_id, company_id } = useParams()
  const langData =  useContext(LanguageContext)
  const [companyLang, setCompanyLang] =  useState([])
  const [prodPlanData, setProdPlanData] = useState([])
  const [planState, planDispatch] = useReducer(ProductionPlanReducer, {
    editable: true,
    rightSideState: 'EMPTY',
    showModal: false,
    submissionStatus: 'FAILED',
    errors: {
      aph: [],
      total_units: [],
      delivery: [],
      legal_files: [],
      selected_contract_type: [],
      inventory_code: [],
      total_acres: [],
      contract_year: []
    }
  })
  const [loadComponet, setloadComponet] = useState(false)

  useEffect(() => {
    const init = async () => {
      const productionPlanData = await getProductionPlan(company_id, 'company_id', true)
      setProdPlanData(productionPlanData)
    }
    if (company_id) {
      init()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company_id, getProductionPlan])

  useEffect(() => {
    getLanguageByCompany(company_id, langData).then(obj => {
      setCompanyLang(obj)
    })
  }, [company_id, langData])

  const checkForErrors = () => {
    let errors = {}
    if(!parseInt(planState.aph)){errors.aph='Missing Aph Value'}
    if(!parseInt(planState.total_acres)){errors.total_acres='Missing total acres Value'}
    if(!parseInt(planState.total_units)){errors.total_units='Missing Total Bushels'}
    if(planState.inventory_code === 'invalid_code'){errors.inventory_code='Please enter a Production Plan inventory code (It should be in capital letter, the length should be 6 and only contain alphabetical letters or numbers)'}
    if(!planState.inventory_code){errors.inventory_code='Please enter a Production Plan inventory code'}

    let legalFileSize = false
    let legalFiletype = false
    if(planState?.legal_files?.length > 0) {
      planState.legal_files.forEach(data => {
        if(!window.atob(data.template_base64).startsWith('%PDF-')) {
          legalFiletype = true
        }
        const binaryData = window.atob(data.template_base64)
        const fileSize = binaryData.length/1000000
        if(fileSize.toFixed(2) > 5) {
          legalFileSize = true
        }
      })
      if(legalFiletype === true) {
        errors.legal_files = 'Wrong file format, it should be PDF'
      }
      else if(legalFileSize === true) {
        errors.legal_files = 'PDF file size should be less than 5MB'
      }
    }

    if(legalFileSize === false) {
      if (planState?.legal_files?.length !== companyLang?.length) {
        let error_flag = false
        if(companyLang?.length > 0)
        {
          let planstate_legal = planState.legal_files? planState.legal_files:  []
          if(planState.legal_files && planstate_legal.length === 0) {
            planstate_legal = planState.legal_files
          }

          // Check if at least one template is uploaded (either new or existing)
          const hasAtLeastOneUpload = planstate_legal?.length > 0 || initial_master_agreement?.length > 0
          if (!hasAtLeastOneUpload) {
            error_flag = true
          }
        }
        if(error_flag) {
          errors.legal_files = 'Missing PDF or wrong file format'
        }
      }
    }
    if (
      !planState.selected_contract_type ||
      !planState.selected_contract_type.contract_type_id
    ) {
      errors.selected_contract_type = 'Missing contract type'
    }
    let availableAcres = true
    planState.monthly_units?.forEach(data => {
      if(data.available_acres && data.available_acres !== '0'){
        availableAcres = false
      }
    })
    if (!planState.monthly_units || !planState.monthly_units.length || availableAcres) {
      errors.delivery =
        'The delivery table must have at least one full delivery month'
    }

    const isProductionPlanExist = prodPlanData.some(data => data.contract_year === planState.contract_year  && data.production_plan_id !== production_plan_id)
    if (isProductionPlanExist) {
      errors.contract_year =
        'Production plan already exists for this year'
    }

    if (JSON.stringify(errors) === '{}') {
      planDispatch({ type: 'NOERRORS', payload: errors })
      return true
    } else {
      planDispatch({ type: 'ERRORS', payload: errors })
      return false
    }
  }

  const updateLegalFile = template_detail => {
    let legalFiles = planState.legal_files
    if(legalFiles?.length > 0) {
      const findIndex = legalFiles.findIndex(x => x.template_language === template_detail.template_language)
      if(findIndex!== -1) {
        legalFiles[findIndex] = template_detail
      } else {
        legalFiles = [...legalFiles, template_detail]
      }
    } else {
      legalFiles = [template_detail]
    }
    planDispatch({
      type: 'UPDATE_LEGAL_FILES',
      payload: legalFiles,
      companyLang: companyLang
    })
  }

  const prevtemplate = lang => {
    if(initial_master_agreement?.length > 0) {
      const index = initial_master_agreement.findIndex(x => x.template_language === lang)
      if(index !== -1)
      {
        return initial_master_agreement[index]
      }
    }
    return false
  }


  const updateContractTemplate = production_plan_id => {
    let updateInsertDone = false
    let promises  = ''
    if(planState?.legal_files?.length > 0)
    {
      promises  = planState.legal_files.map(async legalFile => {
        let patchObj = {}
        let initialMasterAgreement = prevtemplate(legalFile.template_language)
        if (initialMasterAgreement) {
          patchObj.contract_template_id = initialMasterAgreement.contract_template_id
          patchObj.external_reference_id = planState.external_reference_id
          if (legalFile?.template_base64) {
            patchObj.template_base64 = legalFile.template_base64
            patchObj.template_name = legalFile.template_name
          }
          if (
            planState.selected_contract_type.contract_type_id !==
            initial_contract_type.id
          ) {
            patchObj.contract_type_id =
            planState.selected_contract_type.contract_type_id
          }
          patchObj.template_language = legalFile.template_language
          patchObj = production_plan_id ? { ...patchObj, production_plan_id : production_plan_id } : patchObj
          updateInsertDone = true
          return await patchContractTemplate(patchObj)
        }
        else {
          return await uploadContractTemplate(
            planState.selected_contract_type.contract_type_id,
            planState.external_reference_id,
            legalFile.template_base64,
            legalFile.template_name,
            legalFile.template_language,
            production_plan_id
          )
        }
      })
    } else {
      if(initial_contract_type?.id !== planState.selected_contract_type.contract_type_id) {
        initial_master_agreement && initial_master_agreement.length > 0 && initial_master_agreement.map(async legalFile =>
        {
          const updated_agreement = {
            ...legalFile,
            production_plan_id,
            contract_type_id : planState.selected_contract_type.contract_type_id
          }
          return await patchContractTemplate(updated_agreement)
        })
      }
      updateInsertDone = true
    }
    if (updateInsertDone) {
      return Promise.all(promises)
    }
    else {
      return Promise.resolve(true)
    }
  }

  const submitPlan = async() => {
    trackEvent('save_existing_production_plan_clicked', {
      companyId: company_id,
      productionPlanId: production_plan_id
    })
    if (!checkForErrors()) {
      return
    }
    if (production_plan_id) {
      const prodPlanPromise = await patchProductionPlan(planState, production_plan_id)
      const templatePromise = await updateContractTemplate(prodPlanPromise.production_plan_id)

      planDispatch({ type: 'START_POST' })
      try {
        Promise.allSettled([templatePromise, prodPlanPromise]).then(
          values => {
            const templateResult = values[0]
            const prodPlanResult = values[1]
            let submissionStatus = 'SUCCESS'
            let dispatchObj
            if (!templateResult?.value) {
              submissionStatus = 'FAILED_TEMPLATE'
            }
            if (prodPlanResult?.value) {
              dispatchObj = {
                type: 'GO_TO_VIEW_PRODUCTION_PLAN',
                payload: {
                  company_id,
                  productionPlanDetails: prodPlanResult.value,
                  detailView: {
                    title: `${planState.contract_year} Plan: ${prodPlanResult.value.company_name}`,
                    previous: 'Back'
                  }
                }
              }
            } else {
              submissionStatus = 'FAILED'
            }
            planDispatch({
              type: 'POSTS_COMPLETE',
              payload: { submissionStatus, dispatchObj }
            })
          }
        )
      } catch (err) {
        console.error('Promise failed: ', err)
        planDispatch({
          type: 'POSTS_COMPLETE',
          payload: { submissionStatus: 'FAILED' }
        })
      }
    }
  }

  const cancelEdit = () => {
    trackEvent('edit_existing_production_plan_canceled', {
      companyId: company_id,
      productionPlanId: production_plan_id
    })
    dispatch({ type: 'GO_BACK' })
  }

  let detailViewButton = null

  const rightSide = () => {
    switch (planState.rightSideState) {
      case 'FAILED':
        return generateErrors()
      case 'SUCCESS':
        return <p className="c-green m0">Production plan updated!</p>
      default:
        return null
    }
  }

  const generateErrors = () => {
    const errorArray = []
    for (let widget in planState.errors) {
      if (planState.errors[widget].length) {
        planState.errors[widget].forEach((error, index) => {
          errorArray.push(
            <p className="c-red" key={`${error}-${index}`}>
              {error}
            </p>
          )
        })
      }
    }
    return <div className="posf">{errorArray}</div>
  }
  let leftComponents = null
  if (hasPermissison === 'SUCCESS') {
    detailViewButton = (
      <div>
        <Button clickHandler={cancelEdit} customClassName="mb10 mr10">
          Cancel
        </Button>
        <Button
          styleType="success"
          clickHandler={submitPlan}
          customClassName="mb10"
        >
          Save
        </Button>
      </div>
    )
    leftComponents = (
      <>
        <ParentProductionPlanWidget
          parentCompanyInfo={initial_parent_production_plan}
          returnData={planDispatch}
          planState={planState}
        />
        <CompanyDetailsWidget
          companyName={planState.company_name}
          returnData={data =>
            planDispatch({ type: 'UPDATE_COMPANY_DETAILS', payload: data })
          }
        />
        <DeliveryLocationWidget
          deliveryLocationData={initial_delivery_location_data}
          returnData={planDispatch}
        />
        <AvailableContractTypesWidget
          initialType={initial_contract_type}
          contractTypes={contractTypes}
          returnData={planDispatch}
        />
        <UploadLegalFilesWidget
          initialTemplateInfo={initial_master_agreement}
          returnData={planDispatch}
          company_id={company_id}
          updateLegalFile = {updateLegalFile}
        />
        {prodPlanData && <DeliveryWidget
          prevPremiumType={prevPremiumType}
          editable={true}
          initialUnits={initial_total_units}
          initialAcres={initial_total_acres}
          initialAph={initial_aph}
          initialYear={initial_contract_year}
          initialProdInventory={initial_prod_inventory}
          initialMonthlyUnits={initial_monthly_units}
          contractType={planState.selected_contract_type?.contract_type_enum}
          returnData={planDispatch}
          planState={planState}
          parentCompanyInfo={initial_parent_production_plan}
          company_id={company_id}
          prodPlanData={prodPlanData}
          production_plan_id={production_plan_id}
        />}
        <div className="df jcfe mt20 mb50 pl20">{detailViewButton}</div>
      </>
    )
  } else if (hasPermissison === 'FAILED') {
    leftComponents = (
      <>
        <AccessDeniedView />
      </>
    )
  } else {
    leftComponents = (
      <>
        <TableStatus status="LOADING" />
      </>
    )
  }


  useEffect(() => {
    const checkForComponentLoad = async production_plan_id => {
      const planDetails = await getProductionPlan(
        production_plan_id,
        null,
        true
      )
      if(planDetails?.parent_production_plan_id !== 'null') {
        if(initial_parent_production_plan !== undefined && initial_monthly_units !== undefined) {
          setloadComponet(true)
        }
      } else{
        if(initial_monthly_units !== undefined) {
          setloadComponet(true)
        }
      }
    }
    if (production_plan_id) {
      checkForComponentLoad(production_plan_id)
    }
  },[initial_parent_production_plan,initial_monthly_units,production_plan_id])

  useEffect(() => {
    if (planState.updateCompanyDetails) {
      planDispatch({ type: 'FINISHED_UPDATING_COMPANY' })
    }
  }, [planState])

  useEffect(() => {
    const checkForEditAccess = async production_plan_id => {
      const planDetails = await getProductionPlan(
        production_plan_id,
        null,
        true
      )
      setPrevPremiumType(planDetails.premium_type)
      if (planDetails) {
        const access = hasAccess(
          planDetails.external_reference_id,
          'update-production-plan'
        )
        setHasPermission(access === 'SUCCESS' ? 'SUCCESS' : 'FAILED')
      }
    }
    if (production_plan_id && hasAccess() !== 'LOADING') {
      checkForEditAccess(production_plan_id)
    }
  }, [production_plan_id, hasAccess])

  useEffect(() => {
    let canceled = false
    const init = async () => {
      getContractTypes().then(response => {
        if (response && !canceled) {
          setContractTypes(response)
        }
      })
      if (production_plan_id) {
        const planDetails = await getProductionPlan(
          production_plan_id,
          null,
          true
        )
        if (planDetails) {
          getContractTemplates(planDetails.external_reference_id,null, production_plan_id).then(
            res => {
              if (res?.length) {
                set_initial_master_agreement(res)
              }
            }
          )
          const payload = {
            external_reference_id: planDetails.external_reference_id,
            company_name: planDetails.company_name,
            company_inventory_code: planDetails.inventory_code
          }
          const contractTypeExtra = planDetails?.production_plan_extra
          if (contractTypeExtra) {
            set_initial_contract_type({
              id: contractTypeExtra.contract_type_id,
              value: contractTypeExtra.contract_type_enum
            })
            planDispatch({
              type: 'UPDATE_SELECTED_CONTRACT_TYPE',
              payload: contractTypeExtra
            })
          }
          const parproduction_plan_id = planDetails?.parent_production_plan_id
          if (parproduction_plan_id && parproduction_plan_id !== 'null') {
            payload.parent_production_plan_id = parproduction_plan_id
            getProductionPlan(parproduction_plan_id, null, true).then(
              plan => {
                if (plan?.monthly_units?.length) {
                  if (!canceled) {
                    set_initial_parent_production_plan({
                      parentCompanyName: plan.company_name,
                      planYear: plan.monthly_units[0].year,
                      monthly_units: plan.monthly_units,
                      parent_id: plan.production_plan_id
                    })
                  }
                }
              }
            )
          }
          if (!canceled) {
            planDispatch({ type: 'HAS_CONTEXT', payload: payload })
            const response = planDetails.delivery_location
            const delivery_location = {
              location_name: response && response['location_name'],
              location_address1: response && response['location_address1'],
              location_address2: response && response['location_address2'],
              location_city: response && response['location_city'],
              location_state: response && response['location_state'],
              location_zipcode: response && response['location_zipcode'],
              location_country: response && response['location_country']
            }
            set_initial_delivery_location_data(delivery_location)
            set_initial_total_units(planDetails.total_units)
            set_initial_aph(planDetails.aph)
            set_initial_prod_inventory(planDetails.inventory_code)
            set_initial_contract_year(planDetails.contract_year)
            set_initial_monthly_units(planDetails.monthly_units)
            // set contract type info
            if (planDetails.total_acres) {
              set_initial_total_acres(planDetails.total_acres)
            } else {
              let totalAcres = 0
              planDetails.monthly_units?.forEach(unit => {
                totalAcres += parseInt(unit.available_acres)
              })
              set_initial_total_acres(totalAcres)
            }
          }
        }
      }
    }
    init()
    return () => {
      canceled = true
    }
  }, [setContractTypes, production_plan_id])

  const handleClose = result => {
    if (result === 'SUCCESS') {
      dispatch(planState.dispatchObj)
    } else {
      planDispatch({ type: 'SET_MODAL', payload: false })
    }
  }

  return (
    <ProductionPlanContext.Provider value={{ planState, planDispatch }}>
      <DetailView button={detailViewButton}>
        {loadComponet? leftComponents: ''}
        <>
          <div className="m20">{rightSide()}</div>
        </>
      </DetailView>
      <ProductionPlanModal
        handleClose={handleClose}
        submissionStatus={planState.submissionStatus}
        showModal={planState.showModal}
      />
    </ProductionPlanContext.Provider>
  )
}

export default EditProductionPlanView